import { render, staticRenderFns } from "./modalDegustacaoHeader.vue?vue&type=template&id=57897338&scoped=true&"
import script from "./modalDegustacaoHeader.vue?vue&type=script&lang=js&"
export * from "./modalDegustacaoHeader.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=57897338&scoped=true&lang=css&"
import style1 from "./modalDegustacaoHeader.vue?vue&type=style&index=1&id=57897338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57897338",
  null
  
)

export default component.exports